import React, { useEffect, useState } from 'react';
import './index.scss';
import ArticlesStrip from 'containers/magazine/components/ArticlesStrip';
import { AnalyticsParamValues } from '../../../../constants/analytics';
import { useGetMagazineQuery } from 'redux/api/content.api';

const MagazineMain = (props) => {

    const [articles, setArticles] = useState(null);

    const { data: articlesData } = useGetMagazineQuery();


    useEffect(() => {
        if (articlesData) {
            setArticles(articlesData);
        }
    }, [articlesData]);

    return (
    <div className='magazine-main-wrapper'>
        {articles && (
            <>
                {articles.sections.map((sectionData) => {
                    if (sectionData['key']) {
                        return (
                            <ArticlesStrip
                                key={`strip-${sectionData['id']}`}
                                title={sectionData['title']}
                                articles={sectionData['linked_articles']}
                                maxTiles={3}
                                analyticsSource={AnalyticsParamValues.MAGAZINE_PAGE_SOURCE}
                            />
                        );
                    }

                    const articlesData = sectionData['linked_articles'].map((articleLink) => {
                        if (articleLink['article_id'] > 0) {
                            const articleData = articles['articles_data'].find(
                                (articleData) => Number(articleData['id']) === articleLink['article_id']
                            );

                            return articleData;
                        }

                        if (articleLink['video_article_id'] > 0) {
                            const articleData = articles['video_articles_data'].find(
                                (articleData) => Number(articleData['id']) === articleLink['video_article_id']
                            );

                            return articleData;
                        }

                        return articleLink;
                    }).filter(Boolean);

                    return (
                        <ArticlesStrip
                            key={`strip-${sectionData['id']}`}
                            title={sectionData['title']}
                            articles={articlesData}
                            maxTiles={9}
                            analyticsSource={AnalyticsParamValues.MAGAZINE_PAGE_SOURCE}
                        />
                    );
                })}
            </>
        )}
        {!articles && (
            <>
                <ArticlesStrip maxTiles={3} />
                <ArticlesStrip maxTiles={3} />
                <ArticlesStrip maxTiles={3} />
            </>
        )}
    </div>);
}

export default MagazineMain;
